import React, { Fragment, useState, useEffect } from 'react';
import { Button, Form, Alert, FloatingLabel, Col, Row } from 'react-bootstrap';
import SaudeService from '../../../services/saude';
import { Link } from 'react-router-dom';


const Saude = () => {
    const [nomeCompleto, setNomeCompleto] = useState("");
    const [endereco, setEndereco] = useState("");
    const [telefone, setTelefone] = useState("");
    const [municipio, setMunicipio] = useState("");
    const [bairro, setBairro] = useState("");
    const [dataNasc, setDataNasc] = useState("");
    const [email, setEmail] = useState("");
    const [seguimentoSaude, setSeguimentoSaude] = useState("");
    const [eixoDebate, setEixoDebate] = useState("");
    const [inscritoComo, setInscritoComo] = useState("");
    const [conselhoMacuco, setConselhoMacuco] = useState("");
    const [error, setError] = useState([]);
    const [sucesso, setSucesso] = useState(false);
    const [vagas, setVagas] = useState(false);
    const [lotou, setLotou] = useState(false);

    const verificaDelegados = async (e) => {
        if (e === "Delegado") {
            let numdel = await SaudeService.numDel(e)
            numdel.delegados ? setLotou(true) : setInscritoComo(e)
        } else {
            setInscritoComo(e)
        }
    }

    const HandleSubmit = async (evt) => {
        evt.preventDefault()
        try {
            const saude = await SaudeService.cadastro({
                nomeCompleto: nomeCompleto,
                endereco: endereco,
                municipio: municipio,
                telefone: telefone,
                bairro: bairro,
                dataNasc: dataNasc,
                email: email,
                seguimentoSaude: seguimentoSaude,
                eixoDebate: eixoDebate,
                inscritoComo: inscritoComo,
                conselhoMacuco: conselhoMacuco
            })
            if (saude.error === "Não temos mais vagas para delegados") {
                setVagas(true)
            } else {
                setSucesso(true)
                setError(false)
            }
        } catch (error) {
            setError(error)
        }
    }

    if (!sucesso) {
        return (
            <Fragment>
                <Fragment>
                    <p>A 8ª Conferência Municipal de Saúde, organizada pelo Conselho Municipal de Saúde de Macuco com o apoio da Secretaria Municipal de Saúde, será realizada no dia 09 de Março de 2023, no Auditório do Parque de Exposições Edgard Rodrigues Luthebarck, Avenida Jacet Alves de Carvalho, s/n°, Bairro Centro, no horário de 8h às 13h. </p>
                    <p>Nesta edição, o tema central será “Construindo a Saúde de Macuco e Fortalecendo o SUS que dá certo: O amanhã será outro dia!”.</p>
                    <p>Serão discutidos três eixos, os quais são eles:</p>
                    <p>Eixo I - “Fortalecimento da Atenção Primária e Qualificação da Atenção Especializada”;</p>
                    <p>Eixo II - "Financiamento do SUS, Monitoramento e Avaliação dos Instrumentos de Gestão";</p>
                    <p>Eixo III - "Participação Popular e o Papel do Controle Social".</p>
                    <p>A Conferência Municipal de Saúde tem como finalidade avaliar a situação de saúde e elaborar propostas a partir de suas necessidades, subsidiando a gestão em âmbito municipal, no contexto dos 33 anos do SUS, bem como aprofundar o debate sobre as reformas necessárias à democratização do Estado, em especial as que incidem sobre o setor saúde.</p>
                    <a href="https://prefeituramacuco.rj.gov.br/transparencia/arquivos/resolucao-conselho.pdf" target="_blank"><Button variant="primary" type="button">Resolução do Conselho Municipal de Macuco</Button></a><br></br><br></br>
                    <a href="https://prefeituramacuco.rj.gov.br/transparencia/arquivos/comissao-organizadora.pdf" target="_blank"><Button variant="primary" type="button">Comissão Organizadora</Button></a><br></br><br></br>
                    <a href="https://prefeituramacuco.rj.gov.br/transparencia/arquivos/regimento-interno.pdf" target="_blank"><Button variant="primary" type="button">Conheça o Regimento Interno da Conferência</Button></a><br></br><br></br>
                    <a href="https://prefeituramacuco.rj.gov.br/transparencia/arquivos/lei/2023/Decreto%20n%C2%BA%201422-2023.pdf" target="_blank"><Button variant="primary" type="button">Leia o decreto</Button></a><br></br><br></br>
                </Fragment>
                <Fragment>
                    <h2>INSCRIÇÕES ENCERRADAS!</h2><br></br>
                </Fragment>
                {/*<Form onSubmit={HandleSubmit} encType="multipart/form-data">
                    <Row xs={1}>
                        <Col>
                            <Form.Group className="mb-3" controlId="Nome Completo">
                                <FloatingLabel
                                    label="Nome Completo"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="text"
                                        name="nomeCompleto"
                                        value={nomeCompleto}
                                        onChange={e => setNomeCompleto(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group className="mb-3" controlId="Endereço">
                                <FloatingLabel
                                    label="Endereço (Rua e número)"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="text"
                                        name="endereco"
                                        value={endereco}
                                        onChange={e => setEndereco(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group className="mb-3" controlId="Bairro">
                                <FloatingLabel
                                    label="Bairro"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="text"
                                        name="bairro"
                                        value={bairro}
                                        onChange={e => setBairro(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group className="mb-3" controlId="Município">
                                <FloatingLabel
                                    label="Município"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="text"
                                        name="municipio"
                                        value={municipio}
                                        onChange={e => setMunicipio(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group className="mb-3" controlId="Data de Nascimento">
                                <FloatingLabel
                                    label="Data de Nascimento"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="date"
                                        name="dataNasc"
                                        value={dataNasc}
                                        onChange={e => setDataNasc(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group className="mb-3" controlId="WhatsApp">
                                <FloatingLabel
                                    label="WhatsApp (com DDD, apenas números)"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="number"
                                        name="telefone"
                                        placeholder='Exemplo: 22999999999'
                                        value={telefone}
                                        onChange={e => setTelefone(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group className="mb-3" controlId="E-mail">
                                <FloatingLabel
                                    label="E-mail"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="text"
                                        name="email"
                                        value={email}
                                        onChange={e => setEmail(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group className="mb-3" controlId="Categoria: Qual o seguimento de Saúde você representa?">
                                <FloatingLabel
                                    label="Categoria: Qual o seguimento de Saúde você representa?"
                                    className="mb-3"
                                >
                                    <Form.Select
                                        required
                                        aria-label="Categoria: Qual o seguimento de Saúde você representa?"
                                        name="segmentoSaude"
                                        onChange={e => setSeguimentoSaude(e.target.value)}
                                    >
                                        <option value="false">SELECIONE</option>
                                        <option value="Usuário do SUS">Usuário do SUS</option>
                                        <option value="Trabalhador da Saúde">Trabalhador da Saúde</option>
                                        <option value="Gestor ou Prestador de Serviço de Saúde">Gestor ou Prestador de Serviço de Saúde</option>
                                        <option value="Autoridade">Autoridade</option>
                                        <option value="Palestrante">Palestrante</option>
                                        <option value="Comissão Organizadora">Comissão Organizadora</option>
                                    </Form.Select>
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group className="mb-3" controlId="Qual eixo da Conferência Municipal de Saúde deseja participar dos debates?">
                                <FloatingLabel
                                    label="Qual eixo da Conferência Municipal de Saúde deseja participar dos debates?"
                                    className="mb-3"
                                >
                                    <Form.Select
                                        required
                                        aria-label="Qual eixo da Conferência Municipal de Saúde deseja participar dos debates?"
                                        name="eixoDebate"
                                        onChange={e => setEixoDebate(e.target.value)}
                                    >
                                        <option value="false">SELECIONE</option>
                                        <option value="Eixo I - Fortalecimento da Atenção Primária e Qualificação da Atenção Especializada">Eixo I- “Fortalecimento da Atenção Primária e Qualificação da Atenção Especializada”</option>
                                        <option value="Eixo II - Financiamento do SUS, Monitoramento e Avaliação dos Instrumentos de Gestão">Eixo II- “Financiamento do SUS, Monitoramento e Avaliação dos Instrumentos de Gestão”</option>
                                        <option value="Eixo III - Participação Popular e o Papel do Controle Social">Eixo III- “Participação Popular e o Papel do Controle Social”</option>
                                    </Form.Select>
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group className="mb-3" controlId="Deseja se inscrever como?">
                                <FloatingLabel
                                    label="Deseja se inscrever como?"
                                    className="mb-3"
                                >
                                    <Form.Select
                                        required
                                        aria-label="Deseja se inscrever como?"
                                        name="inscritoComo"
                                        onChange={e => verificaDelegados(e.target.value)}
                                    >
                                        <option value="false">SELECIONE</option>
                                        <option value="Delegado">Delegado</option>
                                        <option value="Participante">Participante</option>
                                    </Form.Select>
                                </FloatingLabel>
                                {lotou ? <Alert variant='danger'>Todas as 30 vagas para delegados já foram preenchidas!</Alert> : ''}
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group className="mb-3" controlId="Pertence ao Conselho Municipal de Saúde?">
                                <FloatingLabel
                                    label="Pertence ao Conselho Municipal de Saúde?"
                                    className="mb-3"
                                >
                                    <Form.Select
                                        required
                                        aria-label="Pertence ao Conselho Municipal de Saúde?"
                                        name="conselhoMacuco"
                                        onChange={e => setConselhoMacuco(e.target.value)}
                                    >
                                        <option value="false">SELECIONE</option>
                                        <option value="Sim">Sim</option>
                                        <option value="Não">Não</option>
                                    </Form.Select>
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                    </Row>
                    {error.length >= 1 ? <Alert variant="danger"> {[...error]}</Alert> : ''}
                    <Button variant="primary" type="submit">
                        Enviar inscrição!
                    </Button>
                </Form >
        <br />*/}
                <a href='https://prefeituramacuco.rj.gov.br/transparencia/saude'>
                    <Button variant="danger" type="button">
                        Voltar
                    </Button>
                </a>
            </Fragment >
        )
    } else {
        if (vagas) {
            return (
                <Fragment>
                    <Alert variant='danger'>As 30 vagas para delegados já foram preenchidas!</Alert>
                    <br /><br />
                    <a href='https://prefeituramacuco.rj.gov.br/transparencia/saude'>
                        <Button variant="danger" type="button">
                            Voltar
                        </Button>
                    </a>
                </Fragment>
            )
        } else {
            return (
                <Fragment>
                    <Alert variant='success'>Sua inscrição foi realizada com sucesso!</Alert>
                    <br /><br />
                    <br /><br />
                    <a href='https://prefeituramacuco.rj.gov.br/transparencia/saude'>
                        <Button variant="danger" type="button">
                            Voltar
                        </Button>
                    </a>
                </Fragment>
            )
        }
    }
}

export default Saude;